import { Select } from 'antd';
import { useMemo } from 'react';

import type { SalesFunnelFilterDto } from '@app/api/SalesFunnels';
import {
  getSalesFunnelStageIds,
  mapSalesFunnelsToOptions,
} from '@app/pages/Leads/model/salesFunnelSelection';

import type { FC } from 'react';

import './LeadsFunnelSelectorState.scss';

interface LeadsFunnelSelectorStateProps {
  funnels: SalesFunnelFilterDto[];
  selectedFunnelId: number | null;
  onChange(funnelId: number | null, stageIds: number[]): void;
}

export const LeadsFunnelSelectorState: FC<LeadsFunnelSelectorStateProps> = ({
  funnels,
  selectedFunnelId,
  onChange,
}) => {
  const options = useMemo(() => mapSalesFunnelsToOptions(funnels), [funnels]);

  const changeHandler = (funnelId: number | null) => {
    onChange(funnelId, getSalesFunnelStageIds(funnels, funnelId));
  };

  return (
    <div className="LeadsFunnelSelectorState">
      <div className="LeadsFunnelSelectorState__content">
        <div className="LeadsFunnelSelectorState__text">
          <h3 className="LeadsFunnelSelectorState__title">Выберите воронку</h3>
          <p className="LeadsFunnelSelectorState__description">
            Лиды по этапам появятся после выбора воронки продаж.
          </p>
        </div>

        <Select<number>
          className="LeadsFunnelSelectorState__select"
          size="large"
          allowClear
          showSearch
          placeholder="Воронка продаж"
          optionFilterProp="label"
          options={options}
          value={selectedFunnelId ?? undefined}
          onChange={(value) => changeHandler(value ?? null)}
        />
      </div>
    </div>
  );
};
